import { TableCell, TableRow } from "@mui/material";
import { UserOrg } from "src/types/organization";

import cols from "./Cols";

export default function RowSecret(row: UserOrg) {
	return (
		<TableRow hover>
			{cols.map(({ Cell, align }, index) => (
				<TableCell align={align} key={index}>
					<Cell {...row} />
				</TableCell>
			))}
		</TableRow>
	);
}
